/** * @file * @desc 加载中提示组件 * @author mabiao * @createDate 2018-02-26 * @version v1.0.0 */

<style lang="less" rel="stylesheet/less" scoped>
.loading-pop {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0);
	z-index: 10000;
	.loading-box {
		left: 50%;
		top: 50%;
		width: 2.347rem;
		height: 2.347rem;
		line-height: 2.347rem;
		text-align: center;
		border-radius: 50%;
		overflow: hidden;
		position: absolute;
		margin-top: -1.173rem;
		margin-left: -1.173rem;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: center center;
		animation: loading 1s linear infinite;
		background-color: rgba(255, 255, 255, 0.8);
	}
	.loading-tip {
		font-size: 0.387rem;
		color: #e04e3e;
		letter-spacing: 1px;
	}
}
/* loading动画处理 */
@keyframes loading {
	0% {
		background-image: url(../../image/loading/loading1.png);
	}
	9.09% {
		background-image: url(../../image/loading/loading2.png);
	}
	18.18% {
		background-image: url(../../image/loading/loading3.png);
	}
	27.27% {
		background-image: url(../../image/loading/loading4.png);
	}
	36.36% {
		background-image: url(../../image/loading/loading5.png);
	}
	45.45% {
		background-image: url(../../image/loading/loading6.png);
	}
	54.54% {
		background-image: url(../../image/loading/loading7.png);
	}
	63.63% {
		background-image: url(../../image/loading/loading8.png);
	}
	72.72% {
		background-image: url(../../image/loading/loading9.png);
	}
	81.81% {
		background-image: url(../../image/loading/loading10.png);
	}
	90.91% {
		background-image: url(../../image/loading/loading11.png);
	}
	100% {
		background-image: url(../../image/loading/loading1.png);
	}
}
</style>
<template>
	<div class="loading-pop" @touchmove.stop.prevent="">
		<div class="loading-box">
			<div class="load-effect"></div>
			<div class="loading-tip">
				<slot>
					加载中
				</slot>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'loading'
};
</script>



// WEBPACK FOOTER //
// loadingModel.vue?6497c7c7